const siteUrlFromEnv = (process.env.REACT_APP_SITE_URL || "").trim();

export const DEFAULT_SEO = {
  siteName: "Global Christian Community",
  description: "Uniting believers worldwide through worship, Scripture, and prayer.",
  siteUrl: siteUrlFromEnv || "https://globalchristiancommunity.com",
  image: "/logo512.png",
};
